// extracted by mini-css-extract-plugin
export var actions = "_gj-d";
export var benefitCard = "_gj-a";
export var benefitIcon = "_gj-b";
export var benefitLabel = "_gj-c";
export var benefits = "_gj-9";
export var bodyText = "_gj-8";
export var closeButton = "_gj-2";
export var content = "_gj-3";
export var eyebrow = "_gj-4";
export var heading = "_gj-5";
export var image = "_gj-f";
export var imagePanel = "_gj-e";
export var modal = "_gj-0";
export var shell = "_gj-1";
export var title = "_gj-6";
export var titleOffer = "_gj-7";